// extracted by mini-css-extract-plugin
export default {"refreshLink":"VersionWatcher_refreshLink__dSNyN"};